import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { UserX } from 'lucide-react';

export const AccountDeletedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-lg"
      >
        <Card className="glass border-white/20 dark:border-white/10">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center">
                <UserX className="w-8 h-8 text-muted-foreground" />
              </div>
            </div>
            <CardTitle className="font-['Manrope'] text-xl">You have deleted your profile</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6 text-center">
            <p className="text-muted-foreground leading-relaxed">
              You will not receive any other communications from us. Feel free to create a new account any time.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              If you receive an email that looks like it is from Brioritizer, please make us aware so we can take any necessary actions.
            </p>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              data-testid="account-deleted-home-btn"
            >
              Go to Brioritizer
            </Button>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};
